import React, { Component, useState } from "react";
import {
  TopToolbar,
  RefreshButton,
  SelectInput,
  AutocompleteInput,
  TextField,
  ReferenceInput,
  ArrayInput,
  REDUX_FORM_NAME,
  GET_LIST,
  regex,
  ImageField,
  FormDataConsumer,
  FileInput,
  FileField,
  Toolbar,
  SaveButton,
  ListButton,
  ShowButton,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  required,
  email,
  maxLength,
  useRecordContext,
  Button,
} from "react-admin";
import {
  getSubCategoryChoices,
  getCategoryChoices,
  getComplaintTypeChoices,
  RichTextField,
  getComplaintStatusChoices,
  getLocalStorageKey,
} from "../common/common";
import Select from "react-select";
import FileBase64 from "react-file-base64";
import myDataProvider from "../myRestProvider";
import noImage from "./../images/combined-shape.svg";
import Modal from "react-responsive-modal";
import { useFormContext, useForm, useFieldArray } from "react-hook-form";

// import { change } from 'redux-form';

const validateCategory = [required()];
const validateSubCategory = [required()];
const validateComment = [
  required(),
  regex(/^(?!\s*$).+/, "Enter a valid comment"),
];
// const validateComment = [required(), regex(/^(?![\s-])[\w -]+$/, 'Enter a valid comment')]

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditToolbar = () => (
  <Toolbar>
    <SaveButton alwaysEnable />
  </Toolbar>
);

const EditActions = ({ permissions, basePath, data, resource }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

// const EditForm = () => {
const EditForm = () => {
  const formContext = useFormContext();
  // let fileSizeValidation = false;
  const [fileSizeValidation, setFileSizeValidation] = useState(false);
  const [fileTypeValidation, setFileTypeValidation] = useState(false);
  const [fileExtensionValidation, setFileExtensionValidation] = useState(false);
  const [maxFilesValidation, setMaxFilesValidation] = useState(false);
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState("");
  const [showDeletePop, setShowDeletePop] = useState(false);

  const newTab = (url) => {
    window.open(url, "_blank");
  };
  let adminFileAaayCount = [];
  let businessFileAaayCount = [];
  const showReferenceNo = getLocalStorageKey("show_reference_no");
  return (
    <div>
      <div className="edit-form-container">
        <div className="edit-form-element">
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              return (
                <SelectInput
                  source="comp_type"
                  label="Record Type"
                  choices={getComplaintTypeChoices()}
                  onChange={(event, key, payload) => {
                    if (
                      key !== formData.comp_type_initial ||
                      formData.complaint_category_id !==
                        formData.complaint_category_id_initial
                    ) {
                      formData.complaint_category_id = null;
                      // formData.subcategory_id = null;
                    }
                    // if(key !== formData.comp_type_initial ||
                    //  (formData.subcategory_id !== formData.subcategory_id_initial )){
                    //     formData.subcategory_id = null
                    //  }
                  }}
                />
              );
            }}
          </FormDataConsumer>
        </div>
        <div className="edit-form-element">
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              // console.log('in category_name', formData)
              let choices = [];
              const categoryList = getLocalStorageKey("category_name");
              // console.log('formData ..........', formData)
              // console.log('categoryList && ..........', formData, categoryList && categoryList[0])
              let filterCategory = [];
              if (formData) {
                filterCategory = categoryList.filter(
                  (item) => item.comp_type === formData.comp_type
                );
              }

              // console.log('filterCategory..........', filterCategory)
              filterCategory.map((key) => {
                choices.push({ id: key.id, name: key.display_name });
              });
              // console.log('choices 11212..........', choices)
              if (choices && choices.length > 0) {
                return (
                  <SelectInput
                    source="complaint_category_id"
                    validate={validateCategory}
                    label="Category Name"
                    choices={choices}
                    onChange={(event, key, payload) => {
                      // console.log('our key is ', key)
                      if (
                        key !== formData.complaint_category_id_initial ||
                        formData.subcategory_id !==
                          formData.subcategory_id_initial
                      ) {
                        formData.subcategory_id = null;
                      }
                    }}
                  />
                );
              }
            }}
          </FormDataConsumer>
        </div>

        <div className="edit-form-element">
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              console.log("in subcategory_name");
              let choices = [];
              const categoryList = getLocalStorageKey("subcategory_name");

              let Subcategory = [];

              if (formData) {
                Subcategory = categoryList.filter(
                  (item) =>
                    item.parent_category_id ===
                      formData.complaint_category_id &&
                    item.comp_type === formData.comp_type
                );
              }

              Subcategory.map((key) => {
                choices.push({ id: key.id, name: key.display_name });
              });
              console.log("choices..........", choices);
              if (choices && choices.length > 0) {
                return (
                  <SelectInput
                    source="subcategory_id"
                    validate={validateSubCategory}
                    label="Subcategory Name"
                    choices={choices}
                  />
                );
              }
            }}
          </FormDataConsumer>
        </div>
        <div className="edit-form-element">
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              return (
                <SelectInput
                  source="complaint_status_id"
                  label="Record status"
                  choices={formData?.statuses ? formData?.statuses : []}
                  validate={required()}
                />
              );
            }}
          </FormDataConsumer>
        </div>

        {/* {

                getComplaintStatusChoices().length > 0 &&
                <SelectInput source="complaint_status"
                    label="Complaint Status"
                    choices={getComplaintStatusChoices()}
                    />
            } */}

        {/* <RichTextField source = "comment" /> */}
      </div>
      <div className="customer-service-comment">
        <TextInput
          multiline
          source="comment"
          label="Customer Service Comment"
          validate={validateComment}
        />
      </div>
      <div className="edit-form-element">
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            return (
              <div className="complaint-description-onedit">
                <div className="description-label-onedit">
                  Customer Description
                </div>
                <div className="description-onedit">
                  {formData && formData.description}
                </div>
              </div>
            );
          }}
        </FormDataConsumer>
      </div>
      {showReferenceNo && showReferenceNo.show && (
        <div className="edit-form-element">
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              return (
                <div className="complaint-description-onedit">
                  <div className="description-label-onedit">
                    Reference Numbe
                  </div>
                  <div className="description-onedit">
                    {formData && formData.reference_number}
                  </div>
                </div>
              );
            }}
          </FormDataConsumer>
        </div>
      )}
      <div className="edit-form-element">
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            const deleteFilePop = (e, file) => {
              e.preventDefault();
              console.log("file......", file);
              setShowDeletePop(true);
              setOpen(true);
              setFile(file);
            };

            const deleteFile = (e) => {
              e.preventDefault();
              console.log();
              // formData.complaint_files.sl
              const filteredArr = formData.complaint_files.filter(
                (el) => el.id !== file.id
              );
              console.log("filteredArr", filteredArr);
              formContext.setValue("complaint_files", filteredArr);
              // formData.complaint_files = filteredArr;

              console.log("formData.;.;.;;", formData);
              setShowDeletePop(false);
              // this.setState({
              //     showDeletePop: false,
              // });
            };

            const onCloseModal = () => {
              setShowDeletePop(false);
              // this.setState({ showDeletePop: false });
            };

            return (
              <div>
                <div className="files-uploaded-label">Files Uploaded</div>
                <div className="upload-file-section">
                  <div>
                    {showDeletePop && (
                      <Modal open={open} onClose={onCloseModal} center>
                        <div className="delete-uploaded-file">
                          <h6>Are you sure you want to delete file ?</h6>
                          <div className="delete-file-upload-buttons">
                            <button onClick={(e) => deleteFile(e)}>
                              Delete
                            </button>
                            <button onClick={onCloseModal}>Cancel</button>
                          </div>
                        </div>
                      </Modal>
                    )}
                  </div>

                  <p className="uploaded-files-label">
                    Customer Files Uploaded
                  </p>
                  <div className="uploaded-files-container customer-files-uploaded-onedit">
                    {formData &&
                      formData.complaint_files &&
                      formData.complaint_files.map((file) => {
                        if (file.principle_type === "Business") {
                          businessFileAaayCount.push(file.principle_type);
                        }

                        return (
                          <div
                            className="complaint-file-content"
                            key={file.file_url}
                            onClick={() => {
                              newTab(file.file_url);
                            }}
                          >
                            {file.principle_type === "Business" && (
                              <div>
                                {/* <button onClick={() => { deleteFilePop(file); }}>X</button> */}
                                {file.file_url_data.file_type === "image" ? (
                                  <img
                                    src={file.file_url}
                                    title={file.file_url_data.metadata.filename}
                                  />
                                ) : (
                                  <img
                                    src={noImage}
                                    title={file.file_url_data.metadata.filename}
                                  />
                                )}
                                <p title={file.file_url_data.metadata.filename}>
                                  {file.file_url_data.metadata.filename}
                                </p>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    {businessFileAaayCount.length <= 0 && (
                      <p className="no-files-uploaded">No files uploaded</p>
                    )}
                  </div>
                  <p className="uploaded-files-label">
                    Customer Service Files Uploaded
                  </p>
                  <div className="uploaded-files-container">
                    {formData &&
                      formData.complaint_files &&
                      formData.complaint_files.map((file) => {
                        if (file.principle_type === "AdminPanelUser") {
                          adminFileAaayCount.push(file.principle_type);
                        }
                        return (
                          <div
                            className="complaint-file-content"
                            key={file.file_url}
                          >
                            {file.principle_type === "AdminPanelUser" && (
                              <div>
                                <button
                                  onClick={(e) => {
                                    deleteFilePop(e, file);
                                  }}
                                >
                                  X
                                </button>
                                <div
                                  onClick={() => {
                                    newTab(file.file_url);
                                  }}
                                >
                                  {file.file_url_data.file_type === "image" ? (
                                    <img
                                      src={file.file_url}
                                      title={
                                        file.file_url_data.metadata.filename
                                      }
                                    />
                                  ) : (
                                    <img
                                      src={noImage}
                                      title={
                                        file.file_url_data.metadata.filename
                                      }
                                    />
                                  )}
                                </div>
                                <p title={file.file_url_data.metadata.filename}>
                                  {file.file_url_data.metadata.filename}
                                </p>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    {adminFileAaayCount.length <= 0 && (
                      <p className="no-files-uploaded">No files uploaded</p>
                    )}
                  </div>
                </div>
              </div>
            );
          }}
        </FormDataConsumer>
      </div>

      <div className="add-attachment">
        {/* <ArrayInput> */}
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            const GetFiles = async (files) => {
              setFileTypeValidation(false);
              setFileSizeValidation(false);
              setFileExtensionValidation(false);
              setMaxFilesValidation(files?.length > 10);
              console.log("files", files);
              const maxSize = 10;
              let fileSize = 0;
              const fileExtension = [
                "jpg",
                "jpeg",
                "png",
                "doc",
                "docx",
                "xls",
                "xlsx",
                "ods",
                "odt",
                "csv",
                "pdf",
                "JPG",
                "PNG",
              ];
              const validFileType = [
                "application/pdf",
                "text/csv",
                "application/msword",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "image/gif",
                "image/png",
                "image/jpeg",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.oasis.opendocument.spreadsheet",
                "application/octet-stream",
                "",
              ];
              let seletedArrayType = [];
              let seletedFileExtension = [];
              {
                files.forEach((file) => {
                  fileSize += file.file.size;
                  seletedArrayType.push(file.file.type);
                });
              }
              let extension;
              {
                files.forEach((file) => {
                  // file.file.name.item.split(".").pop(-1);
                  extension = file.file.name.substring(
                    file.file.name.lastIndexOf(".") + 1,
                    file.file.name.length
                  );
                  console.log("extension>>>>>>>>", extension);
                  seletedFileExtension.push(extension.toLowerCase());
                });
              }
              // console.log('seletedFileExtension', seletedFileExtension);
              // console.log('validFileType', validFileType);
              // console.log('seletedArrayType', seletedArrayType);
              if (
                !!seletedFileExtension.some(
                  (val) => fileExtension.indexOf(val) === -1
                )
              ) {
                setFileExtensionValidation(true);
              }

              if (!fileExtensionValidation) {
                if (
                  !!seletedArrayType.some(
                    (val) => validFileType.indexOf(val) === -1
                  )
                ) {
                  setFileTypeValidation(true);
                } else {
                  // formData.files = files

                  for (let x = 0; files.length > x; x++) {
                    let data = compress(files[x]);
                    console.log(data);
                  }
                }
                if (fileSize / 1024 / 1024 > maxSize) {
                  setFileSizeValidation(true);
                } else {
                  // formData.files = files
                  formContext.setValue("files", files);
                }
              }
            };

            const compress = (e) => {
              // console.log(e);
              return new Promise((resolve, reject) => {
                const fileName = e.name;
                const reader = new FileReader();
                reader.readAsDataURL(e.file);
                reader.onload = (event) => {
                  const img = new Image();
                  img.src = event.target.result;
                  img.onload = () => {
                    const elem = document.createElement("canvas");
                    const imgWidth = img.width;
                    const width = (imgWidth / 100) * 75;
                    // const size = img.size / 1024 / 1024;
                    const scaleFactor = width / imgWidth;
                    elem.width = width;
                    elem.height = img.height * scaleFactor;
                    const ctx = elem.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
                    ctx.canvas.toBlob(
                      (blob) => {
                        const file = new File([blob], fileName, {
                          type: "image/jpeg",
                          lastModified: Date.now(),
                        });
                        resolve(true);
                      },
                      "image/jpeg",
                      0.75
                    );
                  };
                  img.onerror = () => {
                    reject(false);
                  };

                  reader.onerror = (error) => reject(false);
                };
              });
            };

            // console.log('hii')
            return (
              <div>
                <div>
                  <p className="upload-files-label">Upload files</p>
                  <FileBase64 multiple={true} onDone={GetFiles} />
                  {fileExtensionValidation && (
                    <div class="complaint-file-error">
                      File extension is not valid
                    </div>
                  )}
                  {maxFilesValidation && (
                    <div class="complaint-file-error">
                      Maximum 10 of files are allowed
                    </div>
                  )}
                  {fileSizeValidation &&
                    !(fileSizeValidation && fileTypeValidation) && (
                      <div className="complaint-file-error">
                        File size is greater than 10 mb
                      </div>
                    )}
                  {fileTypeValidation &&
                    !(fileSizeValidation && fileTypeValidation) && (
                      <div className="complaint-file-error">
                        File type is not valid{" "}
                      </div>
                    )}
                  {fileSizeValidation && fileTypeValidation && (
                    <div className="complaint-file-error">
                      Both File size and type is not valid{" "}
                    </div>
                  )}
                </div>
                <div className="valid-file-upload">
                  <p>Instructions :</p>
                  <ul>
                    <li>
                      Allowed file types: Images: JPEG Image, PNG Image,
                      Documents: PDF document, Microsoft Word document (.docx),
                      Microsoft Excel (.xlsx), Comma Separated Values (.csv),
                      OpenOffice Document (.odf), OpenOffice Spreadsheet (.ods)
                    </li>
                    <li>Max file size (total): 10 MB</li>
                    <li>
                      Please wait till files are uploaded as closing the browser
                      during upload will make the file upload process fail.
                    </li>
                    <li>
                      Uploaded files may take up to 5 minutes to appear
                      depending on the size.
                    </li>
                  </ul>
                </div>
              </div>
            );
          }}
        </FormDataConsumer>
      </div>
    </div>
  );
};

// const FileUpload = ({ record }) => {
//     return (
//         // <div className="disableDropzone">
//         <div>
//             <FileInput source="admin_complaint_files" multiple={true} label="Coming soon ......." placeholder={<p>Drop your file here</p>} multiple >
//                 <FileField source="src" title="title" />
//             </FileInput>
//         </div>)
// }

const EditTitle = () => {
  const record = useRecordContext();
  return (
    <span>Edit Record - {record ? `${record.complaint_number}` : ""}</span>
  );
};

const ShowActions = ({ permissions, basePath, data, resource }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const ComplaintManagementsEdit = ({ permissions, ...props }) => {
  let data;
  return (
    <Edit {...props} title={<EditTitle />} mutationMode="optimistic">
      <SimpleForm toolbar={<EditToolbar />} actions={<ShowActions />}>
        <EditForm />
      </SimpleForm>
    </Edit>
  );
};

export default ComplaintManagementsEdit;
